import { SelectBox } from 'devextreme-react/select-box';
import { useContext } from 'react';
import { useGetCompany } from '../../../../api/company';
import { Field, Panel } from '../../../../layouts';
import { EstimateContext } from '../context/EstimateContext';

export default function StoreInformationPanel() {

	const { order, modifyOrder } = useContext(EstimateContext);
	const store = useGetCompany(order.details.dealerID);
	const proxyStore = useGetCompany(order.details.proxyDealerCompanyID);

	return (
		<>
			<Panel
				header={'Store Information'}
			>
				<Field label={'Parent Company'} >{store.data?.parentCompanyName}</Field>
				<Field label={'Number'} >{store.data?.companyCode + ' - ' + store.data?.companyName}</Field>
				<Field label={'Address'} >{store.data?.PA_Address1}</Field>
				<Field label={''} visible={!!store.data?.PA_Address2}>{store.data?.PA_Address2}</Field>
				<Field label={''} visible={!!store.data?.PA_Zip}>{store.data?.PA_City + ', ' + store.data?.PA_State + ' ' + store.data?.PA_Zip}</Field>
				<Field label={'Phone'} >{store.data?.phone}</Field>
				<Field label={'Fax'} >{store.data?.fax}</Field>
				{
					order.details.proxyDealerCompanyID &&
					<Field label={'Proxy Store'} >{proxyStore.data?.companyCode + ' - ' + proxyStore.data?.companyName}</Field>
				}
				{
					store.data?.IME &&
					<Field label={'IME Status'} >{order.details.imeStatus}</Field>
				}
				<Field label={'Sales Associate Number'} >{order.details.salesAssocNbr}</Field>
				<Field label={'Sales Associate Name'} >{order.details.salesAssocName}</Field>
			</Panel>
		</>
	);
}
